import { format } from 'date-fns'
import { ChargingStation } from '../types'

export const emptyStation = (): ChargingStation => ({
  id: uuidv4(),
  merk: '',
  model: '',
  evseId: '',
  totalVolume: '0',
  registrationDate: new Date().toISOString(),
  sinceDate: format(new Date(new Date().getFullYear(), 0, 1), 'yyyy-MM-dd'),
  autoConnectEnabled: true
})

export function uuidv4() {
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
    const r = (Math.random() * 16) | 0
    const v = c === 'x' ? r : (r & 0x3) | 0x8
    return v.toString(16)
  })
}

export function floorToDecimal(num: number, decimals: number) {
  const factor = 10 ** decimals
  return Math.floor(num * factor) / factor
}
